var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.84365 3.46527L10.2278 4.84944M1 15H2.39775C3.52931 15 4.0951 15 4.60383 14.7893C5.11255 14.5785 5.51267 14.1785 6.31282 13.3783L13.9189 5.77223C14.4221 5.26907 14.6736 5.01753 14.8081 4.74612C15.064 4.2298 15.064 3.62355 14.8081 3.10721C14.6736 2.83582 14.4221 2.58425 13.9189 2.0811C13.4158 1.57796 13.1642 1.32639 12.8928 1.1919C12.3765 0.936032 11.7702 0.936032 11.2539 1.1919C10.9825 1.32639 10.731 1.57796 10.2278 2.0811L2.62166 9.68719C1.82152 10.4873 1.42146 10.8875 1.21073 11.3962C1 11.9049 1 12.4707 1 13.6022V15Z",
    stroke: "#212129",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.515a959fc8c093513bc0bf217c65c886.svg";
export { ForwardRef as ReactComponent };